<template>
    <BoxCreationButton :empty="false"></BoxCreationButton>
</template>

<script>
    import store from '@/store/index.js'
    import Translations from '@/store/translations';
    import BoxCreationButton from './BoxCreationButton.vue'

    export default {
        name: "BoxSectionActions",
        store,
        components: {
            BoxCreationButton
        },
        computed: {
            Translations: () => Translations,
        },
        data() {
            return {}
        }
    }

</script>

<style scoped>
</style>